import * as React from "react";
const SvgChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 7.5L10 12.5L15 7.5", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgChevronDown;
